module.exports = __webpack_public_path__ + "47fec89a.png";